<template>
    <b-card header="Add New Office User"
        header-bg-variant="info"
        header-text-variant="white"
    >
        <form @submit.prevent="saveUser()" autocomplete="off">
            <b-row>
                <b-col lg="6">
                    <b-form-group label="First Name *" label-for="firstname">
                        <b-form-input
                            name="firstname"
                            type="text"
                            v-model="form.firstname"
                            autocomplete="off"
                            required
                        >
                        </b-form-input>

                        <input-help :form="form" field="firstname" text=""></input-help>
                    </b-form-group>

                    <b-form-group label="Last Name *" label-for="lastname">
                        <b-form-input
                            name="lastname"
                            type="text"
                            v-model="form.lastname"
                            autocomplete="off"
                            required
                        >
                        </b-form-input>

                        <input-help :form="form" field="lastname" text=""></input-help>
                    </b-form-group>

                    <b-form-group label="Email Address *">
                        <b-form-input
                            name="email"
                            type="email"
                            v-model="form.email"
                            @change="validateEmail"
                            autocomplete="new-email"
                            required
                        >
                        </b-form-input>

                        <input-help :form="form" field="email" text=""></input-help>

                        <small class="form-text text-muted" v-if="email_not_valid_warning">
                          <span class="text-warning">This email is not a valid email.</span>
                        </small>

                    </b-form-group>

                    <b-form-group label="Password *">
                        <b-form-input
                            name="password"
                            type="password"
                            v-model="form.password"
                            autocomplete="new-password"
                            required
                        >
                        </b-form-input>

                        <input-help :form="form" field="password" text=""></input-help>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col lg="12">
                    <b-button variant="success" :disabled="email_not_valid_warning" size="lg" type="submit">Create User</b-button>
                    <b-button variant="secondary" size="lg" type="button" href="/business/carriers">Cancel</b-button>
                </b-col>
            </b-row>
        </form>

    </b-card>
</template>

<script>
    import UsesRole from '../../mixins/UsesRole';

    export default {
        mixins: [ UsesRole ],
        
        props: {
            admin: false
        },
        data() {
            return {
                form: new Form(),
                email_not_valid_warning: false,
            }
        },
        created(){
            this.setForm();
        },
        methods: {
            validateEmail() {
                if (this.form.email) {
                    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.form.email)) {
                        this.email_not_valid_warning = false
                    } else {
                        this.email_not_valid_warning = true
                    }
                }
            },
            setForm() {
                this.form = new Form({
                    firstname: this.form.firstname,
                    lastname: this.form.lastname,
                    email: this.form.email,
                    password: this.form.password
                })
            },
            async saveUser() {
                let method = 'post'
                let url = this.userRegisterPath

                if (!this.email_not_valid_warning) {
                    const response = await this.form.submit('post','/users/store' );
                }
            }
        }
    }
</script>